import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n/i18n';

const GlobeIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
);

/**
 * Language picker: a button showing the active language code that opens the
 * list of supported languages. The choice is remembered in the browser by the
 * i18next language detector; `onChange(code)` runs after the switch (the
 * navigation bar uses it to save the choice to the user's profile).
 */
const LanguageSwitcher = ({ onChange, className = '', id = 'language-drop', drop = 'down-centered', align, showIcon = false }) => {
    const { t, i18n } = useTranslation();
    const current = SUPPORTED_LANGUAGES.find(l => l.code === (i18n.resolvedLanguage || i18n.language)) || SUPPORTED_LANGUAGES[0];

    const handleSelect = (code) => {
        i18n.changeLanguage(code);
        onChange && onChange(code);
    };

    return (
        <Dropdown className={className} drop={drop} align={align}>
            <Dropdown.Toggle variant="transparent" id={id} title={t('profile.language')} aria-label={t('profile.language')}>
                {showIcon && <GlobeIcon />}
                <span style={{ fontSize: 13, fontWeight: 700 }}>{current.code.toUpperCase()}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ boxShadow: '0 0 10px 2px rgba(0,30,0,0.15)', border: 0, padding: '4px 0', minWidth: 150 }}>
                {SUPPORTED_LANGUAGES.map(({ code, label }) => (
                    <Dropdown.Item key={code} as="button" active={current.code === code}
                        onClick={() => handleSelect(code)}
                        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px', fontSize: 13, fontWeight: current.code === code ? 700 : 500 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, minWidth: 20 }}>{code.toUpperCase()}</span> {label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageSwitcher;
